import { render, staticRenderFns } from "./Started.vue?vue&type=template&id=254bb175&"
import script from "./Started.vue?vue&type=script&lang=js&"
export * from "./Started.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports